import Vue from 'vue'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import 'firebase/firestore'
import 'firebase/storage'
import {config} from './config'

firebase.initializeApp(config)

export const fb = firebase.firestore()
export const db = firebase.database()
export const au = firebase.auth()
export const st = firebase.storage()

Vue.prototype.$au = au
Vue.prototype.$db = db
Vue.prototype.$fb = fb
Vue.prototype.$st = st

